export const PRODUCT_REFRACTORY_PANEL_CEMENT = {
  label: 'Cement Refractory Panel',
  value: 'PRODUCT_REFRACTORY_PANEL_CEMENT'
};
export const PRODUCT_REFRACTORY_PANEL_SKAMOLEX = {
  label: 'Skamolex Refractory Panel',
  value: 'PRODUCT_REFRACTORY_PANEL_SKAMOLEX'
};
